<template>
    <el-dialog
    title="课程绑定试卷"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="100rem">
    <el-radio-group v-model="dataType" @input="search">
        <el-radio label="2">个人试卷</el-radio>
        <el-radio label="1">校企试卷</el-radio>
    </el-radio-group>
    <div style="margin-top: 2rem;display: flex;align-items: center;">
        <el-input style="width: 20rem;" @keydown.enter.native="search" clearable @clear="search"  v-model="paperPages.keywords" placeholder="请输入关键字"></el-input>
        <p style="margin-left: 1rem;cursor: pointer;" @click="search">搜索</p>
    </div>
    <div class="content-box-e">
        <div class="left-box">
            <div class="paper-title">试卷列表</div>
            <no-data v-if="paperPages.total==0"></no-data>
           <div class="list-box" v-else v-infinite-scroll="load">
            <div v-for="(item,index) in tableData" :class="{active:currentId==item.id}" class="paper-item" @click="changePaper(item)" :key="index">
                <p style="flex: 1;" class="overflow">{{ item.testPaperName }}</p>
                <el-tooltip class="item" effect="dark" content="绑定试卷" placement="top-start">
                    <i class="iconfont icon-binding" @click.stop="bindCourse(item,1)"></i>
                </el-tooltip>
            </div>
           </div>
        </div>
        <div class="right-box">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="试卷配置" name="config">
                    <div class="sub-content">
                        <div class="sub-config-item">
                            <p>试卷名称：</p>
                            <p>{{ detail.testPaperName }}</p>
                        </div>
                        <div class="sub-config-item">
                            <p>多选题得分规则：</p>
                            <p>{{ multipleScoringMechanism[detail.multipleScoringMechanism] }}</p>
                        </div>
                        <div class="sub-config-item">
                            <p>及格分数：</p>
                            <p>{{ detail.passMark }}</p>
                        </div>
                        <div class="sub-config-item">
                            <p>组卷方式：</p>
                            <p>{{ setQuestionMode[detail.setQuestionMode]==0?'随机组卷':'手动组卷' }}</p>
                        </div>
                        <div class="sub-config-item">
                            <p>是否打乱题目顺序：</p>
                            <p>{{ shuffleOrder[detail.shuffleOrder] }}</p>
                        </div>
                        <div class="sub-config-item">
                            <p>填空题得分规则：</p>
                            <p>{{ summaryScoringMechanism[detail.summaryScoringMechanism] }}</p>
                        </div>
                        <div class="sub-config-item">
                            <p>考试时长：</p>
                            <p>{{ testDuration(detail.testDuration)}}</p>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="试卷题目" v-if="setQuestionMode!=0" name="subject">
                    <div class="sub-content">
                        <Table
                            :totalSize="paperPages.total"
                            :pagination="true"
                            :operationWidth="350"
                            :currentPage="pages.current"
                            :pageSize="pages.size"
                            @changeCurrentPage="changeCurrentPage"
                            @changePageSize="changePageSize"
                            navHeight=40
                            ref="table"
                            :tableData="subListData"
                            :tableKey="tableKey"
                        ></Table>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
    </el-dialog>
</template>

<script>
import { GetTestPaperInfo,BindOrUnbindCourse,PageCourseTestPaperList,PageQueryTestPaperQuestion } from '@/api/paper';
import NoData from '../../common/NoData.vue';
    export default {
  components: { NoData },
        props:['hasCheckedList'],
        data(){
            return {
                dialogVisible:false,
                tableData:[],
                /**多选得分规则 */
                multipleScoringMechanism:{
                    0:'少选不得分',
                    1:'少选得一半分',
                    2:'少选平均分'
                },
                /**出题方式 */
                setQuestionMode:{
                    0:'随机出题',
                    1:'手动出题'
                },
                /**是否打乱题目顺序 */
                shuffleOrder:{
                    0:'不打乱',
                    1:'打乱'
                },
                /**填空题得分规则 */
                summaryScoringMechanism:{
                    0:'每题错一空不得分',
                    1:'每题每空得平均分'
                },
                /**试卷资源类型 */
                dataType:'2',
                /**当前选择的试卷id */
                currentId:'',
                /**当前试卷组题方式 */
                setQuestionMode:'',
                pages:{
                    current:1,
                    size:10,
                    total:0
                },
                activeName:'config',
                tableKey:[
                {name: '题干', value: 'questionStem',width:'400'},
                {name: '题型', value: 'questionType',},
                {name: '难易度', value: 'difficulty',},
                ],
                paperPages:{
                    keywords:'',
                    current:1,
                    size:10,
                    total:0,
                    flag:false
                },
                /**详情 */
                detail:{},
                /**题目列表数据 */
                subListData:[]
            }
        },
        computed:{
            courseId(){
                return this.$store.state.course.currentCourseId||this.$route.query.id||'';
            }
        },
        methods:{
             /**获取我的未绑定的试卷 */
             pageExamPaper(){
                if(this.pageExamPaper.flag)return;
                this.pageExamPaper.flag=true;
                var params={
                    "bindType": 0,
                    "courseId": this.courseId,
                    "testPaperName":this.paperPages.keywords,
                    "current": this.paperPages.current,
                    "dataType": this.dataType,
                    "size": this.paperPages.size
                }
                PageCourseTestPaperList(params).then(res=>{
                    if(res.code==200){
                        if(this.paperPages.current==1){
                            this.tableData=res.data.records;
                        }else{
                            this.tableData=[...this.tableData,...res.data.records];
                        }
                        this.paperPages.total=res.data.total;
                        if(this.tableData.length>0){
                            this.currentId=this.tableData[0].id;
                            this.setQuestionMode=this.tableData[0].setQuestionMode;
                            if(this.setQuestionMode==0){
                                this.activeName='config';
                            }
                            this.handleClick();
                        }else{
                            this.currentId='';
                            this.setQuestionMode='';
                            this.detail={};
                            this.tableData=[];
                            this.subListData=[];
                        }
                        this.pageExamPaper.flag=false;
                    }
                })
            },
            load(){
                let total=this.paperPages.current*this.paperPages.size;
                if(total>=this.paperPages.total)return;
                this.paperPages.current++;
                this.pageExamPaper();
            },
            /**分页查询试卷题目 */
            pageQueryTestPaperQuestion(){
                let params={
                "current": this.pages.current,
                "size": this.pages.size,
                "testPaperId": this.currentId
                };
                PageQueryTestPaperQuestion(params).then(res=>{
                    if(res.code==200){
                        this.subListData=res.data.records;
                        this.pages.total=res.data.total;
                    }
                })
            },
            /**计算考试时长 */
            testDuration(time){
                if(!time)return '';
                return Number(time)==-1?'无限制':(time/60).toFixed(2)+'min';
            },
            /**绑定课程 */
            bindCourse(item,bindType){
                var params={
                "bindType": bindType,
                "dataType":this.dataType,
                "courseIds": [this.courseId],
                "testPaperIds": [item.id]
                };
                BindOrUnbindCourse(params).then(res=>{
                    if(res.code==200){
                        this.$msg({
                        showClose: true,
                        message: (bindType==1?'绑定':'解除绑定')+"成功",
                        type: "success",
                    });
                    }
                    this.pageExamPaper();
                    this.$emit('bind_success');
                })
            },
            /**获取试卷详情 */
            getTestPaperInfo(id){
                GetTestPaperInfo({id}).then(res=>{
                    if(res.code==200){
                        this.detail=res.data;
                    }
                })
            },
            changeCurrentPage(e){
                this.pages.current=e;
                this.pageQueryTestPaperQuestion();
            },
            changePageSize(e){
                this.pages.size=e;
                this.pages.current=1;
                this.pageQueryTestPaperQuestion();
            },
            /**选择试卷 */
            changePaper(item){
                this.currentId=item.id;
                this.setQuestionMode=item.setQuestionMode;
                if(this.setQuestionMode==0&&this.activeName=='subject'){
                    this.activeName='config';
                }
                this.handleClick();
            },
            search(){
                this.paperPages.current=1;
                this.pageExamPaper();
            },
            handleClick(){
                if(this.activeName=='config'){
                    this.getTestPaperInfo(this.currentId);
                }else{
                    this.pageQueryTestPaperQuestion();
                }
            }
        }
    }
</script>

<style lang="less" scoped>
.content-box-e{
    height: 60rem;
    display: flex;
    margin-top: 2rem;
    .left-box{
        width: 25rem;
        border: 1px solid #e8ecef;
    }
    .right-box{
        flex: 1;
        margin-left: 2rem;
        border: 1px solid #e8ecef;
    }
}
.paper-title{
    font-weight: 700;
    font-size: 14px;
    text-align: center;
    padding: 1rem 0;
    border-bottom: 1px solid #e8ecef;
}
.paper-item{
    padding:0.8rem 1rem;
    cursor: pointer;
    border-bottom: 1px solid #e8ecef;
    justify-content: space-between;
    display: flex;
    align-items: center;
}
.paper-item:hover{
    background-color: var(--blue);
    color: #ffffff;
}
.active{
    background-color: var(--blue) !important;
    color: #ffffff;
}
/deep/.el-tabs__nav-scroll{
    margin-left: 2rem;
}
/deep/.el-tabs__content{
    height: calc(100% - 5.6rem);
}
/deep/.el-tabs {
    height: 100%;
}
/deep/.el-tab-pane{
    height: 100%;
}
.sub-content{
    height: 100%;
    padding:0 2rem 2rem 2rem;
    &> :nth-child(1){
        margin-top: 0 !important;
    }
}
.sub-config-item{
    display: flex;
    align-items: center;
    margin-top: 1rem;
    border-bottom:1px solid var(--hr) ;
    padding-bottom: 1rem;
}
.icon-binding{
    color: #fca130;
    font-size: 14px;
}
.icon-yiguanlian{
    color: #c2e7b0;
    font-size: 16px;
}
.list-box{
    height: calc(100% - 3.6rem);
    overflow: auto;
}
/deep/.el-dialog{
    border-radius: 1rem;
}
</style>